import { BadgeInfo, CircleX } from "lucide-react";

/**
 * AutoCopyInfoBanner Component
 * @param {string} message - The info text to display
 * @param {boolean} show - Whether to show the banner
 * @param {function} onClose - Callback to clear the message
 * @param {string} [className] - Optional extra class names
 */
const AutoCopyInfoBanner = ({ message, show, onClose, className = "" }) => {
  if (!show || !message) return null;

  return (
    <div className={`flex gap-2 items-center p-2 bg-blue-100 ${className}`}>
      <div className="flex items-start gap-1">
        <BadgeInfo
          color="blue"
          strokeWidth={2}
          className="size-6 md:size-[18px] md:pt-[2px]"
        />
        <p className="text-sm text-secondary font-medium">{message}</p>
      </div>
      <div className="cursor-pointer">
        <CircleX onClick={onClose} className="size-6 md:size-[18px]" />
      </div>
    </div>
  );
};

export default AutoCopyInfoBanner;
